module.exports = __webpack_public_path__ + "img/menu_moment.23a46c2d.jpg";